// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import '@/bootstrap.scss';
import 'font-awesome/css/font-awesome.css';

import './registerServiceWorker';
import Moment from 'moment';
import { extendMoment } from 'moment-range';
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Trend from 'vuetrend';
import VueMq from 'vue-mq';
import VueScrollTo from 'vue-scrollto';
import VueLazyload from 'vue-lazyload';
import App from '@/App';
import router from './router';
import store, { i18n } from '@/store';
import config from '@/config';
import VueClipboard from 'vue-clipboard2';
import VueMoment from 'vue-moment';
import VueTruncate from 'vue-truncate-filter';
import VueGtag from 'vue-gtag';
import browserUpdate from 'browser-update';
import * as Sentry from '@sentry/browser';
import VCalendar from 'v-calendar';
import Highcharts from 'highcharts';
import exporting from 'highcharts/modules/exporting';
import noDataHighcharts from 'highcharts/modules/no-data-to-display';

import bFormSlider from 'vue-bootstrap-slider';
import 'bootstrap-slider/dist/css/bootstrap-slider.css';

import VuePlyr from 'vue-plyr';
import './vue-plyr.scss';
Vue.use(VuePlyr);

import black from './assets/black.png';

import VueApexCharts from 'vue-apexcharts';

Vue.component('apexchart', VueApexCharts);
const moment = extendMoment(Moment);
Vue.use(VueMoment, { moment });
Vue.use(bFormSlider);
Vue.use(VueLazyload, {
  observer: true,
  preLoad: 2.5,
  error: black,
  attempt: 1,
});
Vue.use(VueScrollTo);
Vue.use(BootstrapVue);
Vue.use(Trend);
Vue.use(VueClipboard);
Vue.use(VueTruncate);
// Use v-calendar & v-date-picker components
Vue.use(VCalendar);

Vue.use(VueMq, {
  breakpoints: {
    xs: 576,
    sm: 768,
    md: 992,
    lg: 1200,
    xl: Infinity,
  },
});

import { ToastPlugin } from 'bootstrap-vue';
Vue.use(ToastPlugin);
import { ModalPlugin } from 'bootstrap-vue';
Vue.use(ModalPlugin);
import padStart from 'lodash/padStart';
Vue.filter('secsToMinutesSeconds', function(value) {
  const minutes = Math.floor(value / 60);
  const seconds = padStart(value - minutes * 60, 2, '0');

  return `${minutes}' ${seconds}"`;
});

if (config.sentryDsn) {
  Sentry.init({
    dsn: config.sentryDsn,
    integrations: [new Sentry.Integrations.Vue({ Vue })],
    environment: ENVIRONMENT,
    release: VERSION,
  });
}

if (ENVIRONMENT !== 'development') {
  Vue.config.productionTip = false;
}

import FooterNavigation from '@/components/FooterNavigation';
import PhysioFooter from '@/components/FooterPhysio';
Vue.component('default-footer', FooterNavigation);
Vue.component('physio-footer', PhysioFooter);

import feature from './feature';
Vue.component('feature', feature);

router.beforeEach((to, from, next) => {
  store.dispatch('closeLoginModal');
  store.dispatch('closeRateModal');

  next();
});

Vue.use(VueGtag, { config: { id: config.GoogleAnalyticsID } }, router);

Vue.mixin({
  beforeMount() {
    const { asyncData } = this.$options;
    if (asyncData) {
      // assign the fetch operation to a promise
      // so that in components we can do `this.dataPromise.then(...)` to
      // perform other tasks after data is ready
      this.dataPromise = asyncData({
        store: this.$store,
        route: this.$route,
      });
    }
  },
});

exporting(Highcharts);

noDataHighcharts(Highcharts);

const timezone = new Date().getTimezoneOffset();

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: "'Roboto', sans-serif",
    },
  },
  time: {
    timezoneOffset: timezone,
  },
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    loading: 'Daten werden geladen...',
    months: [
      'Januar',
      'Februar',
      'März',
      'April',
      'Mai',
      'Juni',
      'Juli',
      'August',
      'September',
      'Oktober',
      'November',
      'Dezember',
    ],
    weekdays: [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
    ],
    shortMonths: [
      'Jan',
      'Feb',
      'Mär',
      'Apr',
      'Mai',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Okt',
      'Nov',
      'Dez',
    ],
    exportButtonTitle: 'Exportieren',
    printButtonTitle: 'Drucken',
    rangeSelectorFrom: 'Von',
    rangeSelectorTo: 'Bis',
    rangeSelectorZoom: 'Zeitraum',
    downloadPNG: 'Download als PNG-Bild',
    downloadJPEG: 'Download als JPEG-Bild',
    downloadPDF: 'Download als PDF-Dokument',
    downloadSVG: 'Download als SVG-Bild',
    resetZoom: 'Zoom zurücksetzen',
    resetZoomTitle: 'Zoom zurücksetzen',
    viewFullscreen: 'Im Vollbildmodus anzeigen',
    noData: 'Keine Daten vorhanden',
  },
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App },
});

browserUpdate({
  required: {
    i: 999,
  },
  test: false,

  l: store.state.language,
  text_de:
    'Rheumafit.ch ist nicht für diesen Browser optimiert. Bitte verwenden Sie entweder Firefox oder Chrome.',
  text_en:
    'Rheumafit.ch is not optimized for this browser. Please either use Firefox or Chrome.',
  text_fr:
    "Rheumafit.ch n'est pas optimisé pour ce navigateur. Veuillez utiliser Firefox ou Chrome.",
  text_it:
    'Rheumafit.ch non è ottimizzato per questo browser. Si prega di utilizzare Firefox o Chrome.',

  reminder: 0,
  reminderClosed: 1,
  no_permanent_hide: true,
  noclose: true,
});

store.dispatch('setLanguage', store.state.language);



// WEBPACK FOOTER //
// ./src/main.js